const contact = document.getElementById("footer-contact-info");
const aboutUs = document.getElementById("footer-about-us");
const social = document.getElementById("footer-social-links");

const contactSwitch = document.getElementById('contact-heading');
const aboutUsSwitch = document.getElementById('about-us-heading');
const socialSwitch = document.getElementById('social-heading');

function handleClick(element) {
  let contactState = contact.getAttribute("aria-expanded");
  let aboutUsState = aboutUs.getAttribute("aria-expanded");
  let socialState = social.getAttribute("aria-expanded");

  switch (element) {
    case "contact":
      if (contactState === "true") {
        contact.setAttribute("aria-expanded", "false");
      } else {
        contact.setAttribute("aria-expanded", "true");
        aboutUs.setAttribute("aria-expanded", "false");
        social.setAttribute("aria-expanded", "false");
      }
      break;
    case "about":
      if (aboutUsState === "true") {
        aboutUs.setAttribute("aria-expanded", "false");
      } else {
        aboutUs.setAttribute("aria-expanded", "true");
        contact.setAttribute("aria-expanded", "false");
        social.setAttribute("aria-expanded", "false");
      }
      break;
    case "social":
      if (socialState === "true") {
        social.setAttribute("aria-expanded", "false");
      } else {
        social.setAttribute("aria-expanded", "true");
        aboutUs.setAttribute("aria-expanded", "false");
        contact.setAttribute("aria-expanded", "false");
      }
      break;
  }
}

contactSwitch.addEventListener("click", () => handleClick("contact"));
aboutUsSwitch.addEventListener("click", () => handleClick("about"));
socialSwitch.addEventListener("click", () => handleClick("social"));
